<template>
<div>
    <NavigationMenu />

    <header class="bg-gradient-to-r from-green-700 to-green-600 shadow-lg">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-center gap-3">
          <div class="flex items-center justify-center w-12 h-12 rounded-xl bg-white bg-opacity-20 backdrop-blur-sm">
            <i class="fas fa-trophy text-2xl text-white"></i>
          </div>
          <div class="text-center sm:text-left">
            <h1 class="text-3xl font-bold text-white">
              Bolão do Brasileiro
            </h1>
            <p class="hidden sm:block text-green-100 text-sm mt-0.5">
              Relatórios e histórico do ranking
            </p>
          </div>
        </div>
      </div>
    </header>

    <div class="container mx-auto lg:flex mt-4 justify-between px-2 sm:p-0 sm:mt-4">
        <NavigationBetting />
        
        <div class="w-full sm:w-8/12 lg:w-9/12 mx-auto mr-0">
          <RankingReportTable :userData=userData />
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationMenu from '@/components/NavigationMenu';
import NavigationBetting from '@/components/NavigationBetting';
import RankingReportTable from '@/components/RankingReportTable';
import UserService from '@/services/userService';

export default {
  name: 'ReportsBetting',
  components: {
    NavigationMenu,
    RankingReportTable,
    NavigationBetting
  },
  created() {
    this.userData = UserService.getUserData();
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  },
  data(){
    return {
      userData: null,
    }
  },
}
</script>